// Número de WhatsApp del admin al que se envía el detalle de cada reserva.
// Formato internacional sin '+' ni espacios (España +34). Tel: 625 46 34 20
export const ADMIN_WHATSAPP = '34625463420';

export interface WhatsAppBookingDetails {
  serviceName: string;
  /** Fecha ya formateada para lectura humana, p.ej. "15 de Mayo de 2026" */
  date: string;
  time: string;
  name: string;
  email: string;
  phone?: string;
  notes?: string;
  price?: number;
}

/**
 * Construye una URL wa.me con el detalle de la cita pre-redactado.
 * Al abrirla, el cliente ve el mensaje listo y solo pulsa "enviar" hacia
 * el WhatsApp del admin.
 */
export function buildAppointmentWhatsAppUrl(b: WhatsAppBookingDetails): string {
  const lines = [
    '🗓️ *Nueva reserva de cita*',
    '',
    `*Servicio:* ${b.serviceName}`,
    `*Fecha:* ${b.date}`,
    `*Hora:* ${b.time}`,
    '',
    `*Cliente:* ${b.name}`,
    `*Email:* ${b.email}`,
    b.phone ? `*Teléfono:* ${b.phone}` : null,
    b.price && b.price > 0 ? `*Importe:* €${b.price.toFixed(2)}` : null,
    b.notes ? `*Notas:* ${b.notes}` : null,
  ].filter(Boolean) as string[];

  const text = encodeURIComponent(lines.join('\n'));
  return `https://wa.me/${ADMIN_WHATSAPP}?text=${text}`;
}
